var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageContainer"},[_c('index',{attrs:{"type":_vm.type},on:{"setType":_vm.settype}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }